import type { IDomains } from "app/pages/industry-analysis/market-builder/MarketBuilder.types";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import type { ICountryObject } from "app/services/CountryService";

interface IRecord {
    Domain: string;
}

type IDomainRecord = Array<IRecord>;

interface ITableData {
    Records: IDomainRecord;
    TotalCount: number;
}

export const getTableData = (
    rawData: { TotalCount: number; Data: Array<{ Domain: string }> },
    selectedDomains: IDomains,
    country: ICountryObject,
): ITableData => {
    const { TotalCount: totalCount, Data: data } = rawData;
    const selectedDomainsSet = new Set(selectedDomains.map(({ domain }) => domain));
    const params = proNavigator.getParams();
    const filterSelectedDomains = ({ Domain: domain }) => {
        return !selectedDomainsSet.has(domain);
    };
    const records = data.filter(filterSelectedDomains).map((record) => {
        const { Domain: domain } = record;
        const url = proNavigator.href("digitalsuite_website_websiteperformance", {
            ...params,
            key: domain,
            isWWW: "*",
            country: country.id,
        });
        return {
            ...record,
            url,
        };
    });

    const tableData = { TotalCount: totalCount - selectedDomains.length, Records: records };
    return tableData;
};
